import { ComponentType, type IConfig } from '../types';

export type ConfigMapping = Record<ComponentType, IConfig>;

const configs = import.meta.glob('./*/config.ts', { eager: true });

export const CONFIG_MAPPING: ConfigMapping = Object.fromEntries(
  Object.entries(configs).map(([path, mod]) => {
    const folder = path.split('/')[1];
    const config = (mod as any).config as IConfig;
    const key = config.component || folder;
    return [key, config] as const;
  })
) as ConfigMapping;
